import { PublicationAggregatedMetricsEntity } from "../../data/entities/publication-aggregated-metrics.entity";
import {
  MetricsSeriesDataPoint,
  PublicationAggregatedMetrics,
} from "../models/publication-aggregated-metrics";

export class PublicationAggregatedMetricsEntityToPublicationAggregatedMetricsMapper {
  public map(
    from: PublicationAggregatedMetricsEntity,
  ): PublicationAggregatedMetrics {
    return {
      lastUpdatedAt: from.lastUpdatedAt
        ? new Date(from.lastUpdatedAt)
        : undefined,
      totals: from.totals,
      series: Object.keys(from.series).reduce<
        Record<string, MetricsSeriesDataPoint[]>
      >((acc, key) => {
        const seriesEntityArray = from.series[key];
        acc[key] = seriesEntityArray.map((seriesEntity) => ({
          date: new Date(seriesEntity.time),
          value: seriesEntity.value,
        }));
        return acc;
      }, {}),
    };
  }
}
